import {
  SPI,
  ActionWidget,
  ActionWidgetProps,
  RuntimeServerAction,
  ServerActionWidget,
  ClickResult,
  FormO2MTableFieldWidget,
  FormWidget,
  translateValueByKey
} from '@kunlun/dependencies';
import { debugConsole, OioNotification } from '@kunlun/vue-ui-antd';
import { ActiveRecords, FunctionCache, FunctionService, RequestModelField, RuntimeFunctionDefinition, StaticMetadata, SubmitValue } from '@kunlun/engine';
@SPI.ClassFactory(
  ActionWidget.Token({
    model: 'deli.retail.BackendRetailItemCategoryProxy',
    name: ['updateItemCategory', 'deleteItemCategory', 'createItemCategory']
  })
)
export class RefreshCategoryAction extends ServerActionWidget {
  initialize(props: ActionWidgetProps<RuntimeServerAction>): this {
    super.initialize(props);
    return this;
  }

  protected async clickAction(): Promise<ClickResult> {
    const { action } = this;
    if (!action) {
      console.error('无法处理没有运行时动作的点击动作');
      return;
    }
    debugConsole.group(`Click serverAction. ${action.model}:${action.name}`);
    const submitValue = await this.submit(action);
    const itemList = (this.getParentWidget()?.getParentWidget() as any)?.parentActiveRecords;
    const params = { ...submitValue.records, itemList };
    submitValue.records = params;
    try {
      return await this.executeAction(action, submitValue);
    } catch (e) {
      console.error(e);
      const { forceRefreshWhenError = false } = this.getDsl();
      if (forceRefreshWhenError) {
        this.refreshCallChaining?.syncCall();
      }

      return false;
    } finally {
      debugConsole.groupEnd();
    }
  }
  protected executeFunctionByCustom<T>(functionDefinition: RuntimeFunctionDefinition, requestFields: RequestModelField[], activeRecords: ActiveRecords | undefined): Promise<T> {
    return FunctionService.INSTANCE.simpleExecute(
      this.model,
      functionDefinition,
      {
        requestModels: [StaticMetadata.ResourceAddress],
        requestFields,
        variables: { path: this.action.sessionPath }
      },
      activeRecords
    );
  }
  protected async executeAction(action: RuntimeServerAction, submitValue: SubmitValue): Promise<ClickResult> {
    if ((this.updateOneWithRelationName === action.fun || this.updateActionName === action.name) && this.usingDiffUpdate(submitValue)) {
      const requestFields = await this.getRequestModelFields();
      return this.executeRelationUpdate(requestFields, submitValue);
    }
    let { functionDefinition } = action;
    const { model, fun } = action;
    if (!functionDefinition && fun) {
      functionDefinition = await FunctionCache.get(model, fun);
    }
    if (!functionDefinition) {
      console.error('无法获取可执行函数', action);
      OioNotification.error(translateValueByKey('错误'), translateValueByKey('无法获取可执行函数'));
      return false;
    }
    const requestFields = await this.getRequestModelFields();
    return this.executeFunctionByCustom(functionDefinition, requestFields, submitValue.records);
  }

  protected async clickActionAfter(result: ClickResult): Promise<ClickResult> {
    try {
      if (this.action.name === 'updateItemCategory' || this.action.name === 'createItemCategory') {
        const { category } = result as any;
        const itemList = (this.getParentWidget()?.getParentWidget() as any)?.parentActiveRecords;
        if (!category || !Array.isArray(itemList)) {
          return null;
        }

        const params = {
          category: category,
          itemList: itemList.map((i) => {
            return { id: i.id };
          })
        };

        super.clickActionAfter(params);
      } else {
        super.clickActionAfter(result);
      }

      let widget = this.getParentWidget() as any;
      while (!(widget instanceof FormWidget)) {
        widget = widget?.getParentWidget?.();
      }
      if (!widget) {
        return;
      }
      (widget as any).refreshCallChaining?.syncCall();
    } catch (error) {
      console.error(error);
    }
  }
}
